import { Shield } from 'lucide-react';
import { PiSparkle } from 'react-icons/pi';
import { DialogModal } from './DialogModal';
import EmptyStateAddButtons, { EmptyStateAddOptionDef } from './EmptyStateAddButtons';

export type AddInsuranceOptionsModalProps = {
  open: boolean;
  onClose: () => void;
  onAnalyzeExistingPolicy: () => void;
  onShopNewInsurance: () => void;
};

export function AddInsuranceOptionsModal({
  open,
  onClose,
  onAnalyzeExistingPolicy,
  onShopNewInsurance,
}: AddInsuranceOptionsModalProps) {
  const options: EmptyStateAddOptionDef[] = [
    {
      title: 'Analyze Existing Policy',
      description: ' or enter details of a policy you already have.',
      icon: PiSparkle,
      onClick: onAnalyzeExistingPolicy,
      testId: 'add-insurance-options-analyze-existing-policy',
    },
    {
      title: 'Explore Coverage Options',
      description: 'Explore available policies and get recommendations.',
      icon: Shield,
      onClick: onShopNewInsurance,
      poweredBy: 'Powered by Wealth Assurance Group',
      testId: 'add-insurance-options-explore-coverage',
    },
  ];

  return (
    <DialogModal
      open={open}
      onClose={onClose}
      title="How would you like to add insurance?"
      subTitle="Upload or enter details of a policy you already have, or shop for new insurance."
    >
      <EmptyStateAddButtons
        addOptions={options}
        forModal
      />
    </DialogModal>
  );
}
